import InlineComponent from './inlineComponent.jsx';
import HashBuilder from '../../../components/hash/HashBuilder.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = HashBuilder;
  }
};
